export default __webpack_public_path__ + "static/media/FP_FM_GR_F.07f0fb0c.png";